import useAccountData from "hooks/useAccountData";
import { Company } from "models/Company";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

export default function BreadcrumbCompany() {
    let params = useParams();
    const {getCurrentCompany, loadingCompanies} = useAccountData();
    const [data, setData] = useState<Company | null>()

    useEffect(() => {
        async function fetchData() {
            if(loadingCompanies) {
                const response = await getCurrentCompany(params.id as string);
                setData(response);
            }
        }
        fetchData();
    }, [getCurrentCompany, loadingCompanies, params.id]);
    return (
        <>
            {data === null ? (<></>) : (
                <>
                    <p className="text-secondary cc-company-name-details">
                        <Link to={UrlPath.MyAccount.Home}>
                            <small>&larr; {data?.name} Org nr: {data?.companyCode}. Juridisk navn: {data?.legalName}</small>
                        </Link>
                    </p>
                </>
            )}
        </>);
}